export const apiUrl = 'https://api-website.livechatinc.com'



// WEBPACK FOOTER //
// ./src/config/app.prod.js